import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Button, FormHeader, InputBox } from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { useDispatch, useSelector } from "react-redux";
import { createNewTag, updateTag } from "../../Tags/service/tags.service";
import { Store } from "react-notifications-component";
import { clearSelectedTag, updateTagsList } from "../../Tags/redux/actions";
import { clearedSelectItems } from "../../advertisement/redux/actions";
import { getLanguage } from "../../../utils";

const lan = getLanguage();

const CreateNewTags = (props) => {
  const dispatch = useDispatch();
  const selectedTag = useSelector((state) => state.tagsReducer.selectedTag);
  // const { newsList } = useSelector(({ newsReducer }) => newsReducer);

  const [selectedTagList, setSelectedTagList] = useState([]);
  const [selectTagList, setSelectTagList] = useState([]);
  const [selectedNews, setSelectNews] = useState([]);
  const [language, setLanguage] = useState(lan);
  const [selectList, setSelectList] = useState([]);
  const [newsList, setNewsList] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);

  const [formData, setFormData] = useState({
    tagName: {
      key: "tagName",
      label: "Tag Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Find news",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setSelectNews([]);
    setFilteredTags([]);
    setSelectTagList([]);
    setFormData(updateForm);

    props.refresh();
  };

  useEffect(() => {
    if (selectedTag?.tag_id) {
      console.log("id", selectedTag.tag_id);
      const updatedForm = {
        ...formData,
      };
      updateForm["tagName"].value = selectedTag?.tag_name;

      setFormData(updatedForm);
    } else {
      for (let key in updateForm) {
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
    }
  }, [selectedTag]);

  const onClickCreate = async () => {
    setIsLoading(true);

    const updateForm = { ...formData };
    try {
      let body = {
        tag_name: updateForm.tagName.value,
      };

      const response = await createNewTag(body);
      console.log("Tag Response:", response);
      setIsLoading(false);

      if (response?.data) {
        console.log("Tag Created Successfully");
        Store.addNotification({
          title: "Success!",
          message: "Tag Created Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        clearAll();
      }
    } catch (error) {
      console.log("Error creating Tag");
      Store.addNotification({
        title: "Error!",
        message: "Tag Create Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      clearAll();
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    if (selectedTag?.tag_id) {
      const updateForm = { ...formData };
      const body = {
        tag_name: updateForm.tagName.value,
      };
      const response = await updateTag(body, selectedTag?.tag_id);
      console.log("Update Tag Response:", response);
      setIsLoading(false);
      try {
        if (response?.data?.status) {
          dispatch(updateTagsList(response.data?.data));

          Store.addNotification({
            title: "Success!",
            message: "Tag Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);

          clearAll();
        }
      } catch (error) {
        console.log("Error updating Tag");
        Store.addNotification({
          title: "Error!",
          message: "Tag Update Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);

        clearAll();
      }
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-tag-wrapper">
        <FormHeader
          data={{
            formHeader: "Create Tags",
            size: "md-md",
          }}
        />
        <div className="hne-tag-header-wrapper">
          <InputBox
            data={updateForm.tagName}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(e.target.value, updateForm.tagName.key);
            }}
          />
        </div>
        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "15px" }}
        >
          {selectedTag?.tag_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                dispatch(clearSelectedTag());
                clearAll();
              }}
            />
          )}
          <Button
            data={{
              btnName: selectedTag?.tag_id ? "UPDATE" : "DONE",
              buttonType:
                updateForm.tagName.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable: updateForm.tagName.value === "" ? true : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectedTag?.tag_id) {
                await onClickUpdate(e);
              } else {
                await onClickCreate(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(CreateNewTags);
